import styled from "styled-components";

import { UserDataStyledProps as Props } from "./UserData.types";
import CONSTANTS from "config/constants";

const { tablet, mobile } = CONSTANTS.BREAKPOINTS;

const UserDataStyled = styled.div<Props>`
  display: flex;
  align-items: flex-end;
  margin-bottom: 5.6rem;

  .UserData {
    &__header {
      display: ${props =>
        props.isProfile || props.isAnonymous ? "block" : "flex"};
      font-weight: 600;
      font-size: 2.8rem;
      line-height: 3.2rem;

      @media (max-width: ${tablet - 1}px) {
        font-size: 2.4rem;
        display: block;
      }

      &__title {
        font-size: 2.4rem;
        color: var(--palette-white);
      }

      &__description {
        padding-top: 1.6rem;
        padding-bottom: 2.4rem;
        font-size: 1.6rem;
        color: var(--palette-gray-s0-l80);
        font-weight: 500;
        width: 56%;
        line-height: normal;

        @media (max-width: ${tablet}px) {
          width: 100%;
        }
      }

      &__hello {
        color: var(--palette-white);
        padding-right: 0.8rem;
      }

      &__text {
        color: ${props =>
          props.isProfile
            ? "var(--palette-white)"
            : "var(--palette-gray-s0-l80)"};
      }
    }

    &__buttons {
      display: flex;

      &__social {
        border-radius: 50%;
        padding: 1rem;
        background-color: var(--palette-white);
        border: none;
        margin-right: 1.2rem;
        cursor: pointer;
        align-self: center;
        display: flex;

        @media (max-width: ${mobile - 1}px) {
          margin-right: 0.8rem;
        }
      }
    }

    &__button {
      border-radius: 8rem;
      height: 4rem;
      margin-left: 2.4rem;

      @media (max-width: ${mobile}px) {
        margin-left: 0;
        margin-top: 1.6rem;
      }
    }
  }
`;

export default UserDataStyled;
